import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { previews } from '../data/previews';
export function PagePreviews() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const updateEdges = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setAtStart(el.scrollLeft <= 8);
    setAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 8);
  }, []);
  useEffect(() => {
    updateEdges();
    window.addEventListener('resize', updateEdges);
    return () => window.removeEventListener('resize', updateEdges);
  }, [updateEdges]);
  const scrollByCard = (direction: 1 | -1) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector('li');
    const amount = card ? card.clientWidth + 20 : el.clientWidth * 0.8;
    el.scrollBy({
      left: amount * direction,
      behavior: 'smooth'
    });
  };
  return <section aria-label="Anteprima delle pagine interne" className="bg-transparent" data-id="element-117" data-mp="343ujsif8f9zh">
      <div className="mx-auto max-w-6xl px-5 pb-12 pt-2" data-id="element-118" data-mp="392nts0vb8iuw">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-119" data-mp="3e0pfyuo18yal">
          <div data-id="element-120" data-mp="3dymdvc9lvepi">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-121" data-mp="3dyuunf8un45z">
              👀 Sbircia dentro
            </p>
            <h2 className="mt-2 font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-122" data-mp="3mtsocojtmkyd">
              Alcune pagine reali del metodo
            </h2>
            <p className="mt-2 max-w-xl text-sm text-plum/60" data-id="element-123" data-mp="3ru6w05hifsvv">
              Schede visive, tabelle di pronuncia e frasi pronte all'uso: questo è l'aspetto vero
              dei tomi e dei bonus.
            </p>
          </div>

          <div className="hidden gap-2 sm:flex" data-id="element-124" data-mp="22dfmz1d9hjk5">
            <button type="button" onClick={() => scrollByCard(-1)} disabled={atStart} aria-label="Pagina precedente" className="flex h-10 w-10 items-center justify-center rounded-full border border-grape/25 bg-white text-grape transition-[background-color,opacity] duration-150 ease-out hover:bg-lilac-soft disabled:opacity-35 focus:outline-none focus-visible:ring-2 focus-visible:ring-grape" data-id="element-125" data-mp="22eqqr16pirb9">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-126" data-mp="249mch0ukvjue" />
            </button>
            <button type="button" onClick={() => scrollByCard(1)} disabled={atEnd} aria-label="Pagina successiva" className="flex h-10 w-10 items-center justify-center rounded-full border border-grape/25 bg-white text-grape transition-[background-color,opacity] duration-150 ease-out hover:bg-lilac-soft disabled:opacity-35 focus:outline-none focus-visible:ring-2 focus-visible:ring-grape" data-id="element-127" data-mp="2ia5glwvxa5ra">
              <ChevronRightIcon className="h-5 w-5" data-id="element-128" data-mp="30yk80la5jlsm" />
            </button>
          </div>
        </div>

        <ul ref={trackRef} onScroll={updateEdges} tabIndex={0} className="mt-8 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-4 [scrollbar-width:thin] focus:outline-none focus-visible:ring-2 focus-visible:ring-grape" data-id="element-129" data-mp="2wxib4b3pjltt">
          {previews.map((p, i) => <li key={p.id} className="w-[240px] shrink-0 snap-start sm:w-[280px]" data-id="element-130" data-mp="3bls0hp9bwtrq" data-mpi={i}>
              <figure className="flex h-full flex-col overflow-hidden rounded-2xl border border-grape/15 bg-white shadow-[0_16px_40px_-28px_rgba(46,16,101,0.55)]" data-id="element-131" data-mp="2wwvsttb6pirn">
                <div className="relative aspect-[4/5] w-full overflow-hidden bg-lilac-soft" data-id="element-132" data-mp="2nwfuszd7n3u6">
                  <img src={p.src} alt={p.caption} width={1080} height={1350} loading={i < 2 ? 'eager' : 'lazy'} decoding="async" sizes="(min-width: 640px) 280px, 240px" className="h-full w-full object-cover object-top" data-id="element-133" data-mp="2numltdf4k7j0" />
                  <span className="absolute left-3 top-3 rounded-full bg-plum/85 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-white" data-id="element-134" data-mp="3lclpnn3xd85w">
                    {p.tag}
                  </span>
                </div>
                <figcaption className="flex-1 px-4 py-4 text-[13px] font-semibold leading-relaxed text-plum/75" data-id="element-135" data-mp="37jw1pd4u5t65">
                  {p.caption}
                </figcaption>
              </figure>
            </li>)}
        </ul>

        <p className="mt-1 text-center text-xs font-medium text-plum/45 sm:hidden" data-id="element-136" data-mp="2xjmz9hk93bib">
          ← Scorri per vedere tutte le pagine →
        </p>
      </div>
    </section>;
}